import { useContext } from 'react';
import styled from '@emotion/styled';
import { TagGeneratingFilesContext } from '@trinity/chat-components/containers/Workspace/context.js';
import { format } from 'date-fns';
import { SkeletonTags } from '@/components/presentation/Skeleton.Tags';
import * as Tab from '@/components/presentation/Workspace.Tab.Pane';
import { WorkspaceFilePreviewLoadingContext } from '@/containers/Workspace.File.Preview/Context';
import { useWorkspaceFileState } from '@/containers/Workspace.File.Preview/hooks';
import styles from './style/Tab.Details.module.css';
import { useGroupEntityTags, useGroupEntityTagsUpdate } from '@trinity/chat-components/contexts/group-tags/hooks/index.js';
import { GroupSidebarTags } from '@trinity/chat-components/components/GroupSidebarTags/GroupSidebarTags.js';

type Props = unknown;

export const FileTabDetails = (props: Props) => {
  const { file, object } = useWorkspaceFileState();

  // Guard against missing data
  if (!object) {
    return null;
  }

  // const filteredAuthors = file.authors.filter(f => !!f.name || !!f.affiliation);

  return (
    <Tab.Panes.Container>
      <Tab.Pane.Pane>
        <Tab.Pane.Title>Details</Tab.Pane.Title>
        <Tab.Items.Container>
          <Tab.Item.Container>
            <Tab.Item.TextLabel>Name</Tab.Item.TextLabel>
            <Tab.Item.Value>{object.name || 'Untitled'}</Tab.Item.Value>
          </Tab.Item.Container>

          <Tab.Item.Container>
            <Tab.Item.TextLabel>Owner</Tab.Item.TextLabel>
            <Tab.Item.Value>{object.owner?.name || 'Unknown'}</Tab.Item.Value>
          </Tab.Item.Container>

          {/* <Tab.Item.Container>
            <Tab.Item.TextLabel>Authors</Tab.Item.TextLabel>
            <Tab.Item.Value>
              {filteredAuthors.length ? (
                filteredAuthors.map(({ name, affiliation }, index) => (
                  <div key={index}>
                    {[name, affiliation].filter(Boolean).join(', ')}
                  </div>
                ))
              ) : (
                <>None</>
              )}
            </Tab.Item.Value>
          </Tab.Item.Container>

          <Tab.Item.Container>
            <Tab.Item.TextLabel>Title</Tab.Item.TextLabel>
            <Tab.Item.Value>{file.title || 'Unknown'}</Tab.Item.Value>
          </Tab.Item.Container> */}

          <Tab.Items.Row>
            <Tab.Item.Container className={styles.field}>
              <Tab.Item.TextLabel>Uploaded On</Tab.Item.TextLabel>
              <Tab.Item.Value>{object.createdOn ? format(object.createdOn, 'M/d/yyyy') : 'Unknown'}</Tab.Item.Value>
            </Tab.Item.Container>
          </Tab.Items.Row>

          <Tab.Items.Row>
            <Tab.Item.Container className={styles.field}>
              <Tab.Item.TextLabel>Published On</Tab.Item.TextLabel>
              <Tab.Item.Value>{file?.publishedOn ? format(file.publishedOn, 'M/d/yyyy') : 'None'}</Tab.Item.Value>
            </Tab.Item.Container>

            <Tab.Item.Container className={styles.field}>
              <Tab.Item.TextLabel>Expiration Date</Tab.Item.TextLabel>
              <Tab.Item.Value>{object.expiresOn ? format(object.expiresOn, 'M/d/yyyy') : 'None'}</Tab.Item.Value>
            </Tab.Item.Container>
          </Tab.Items.Row>
        </Tab.Items.Container>
      </Tab.Pane.Pane>

      <TagPane />

    </Tab.Panes.Container>
  );
};

function TagPane() {
  const tagGeneratingContext = useContext(TagGeneratingFilesContext);
  const { file } = useWorkspaceFileState();

  const fileId = file?.id;
  const isGenerating = fileId && tagGeneratingContext?.isGenerating(fileId);

  const tags = useGroupEntityTags();
  const updateTags = useGroupEntityTagsUpdate();

  if (isGenerating) {
    return (
      <Tab.Pane.Pane>
        <Tab.Pane.Title>Tags</Tab.Pane.Title>
        <SkeletonTags count={3} />
      </Tab.Pane.Pane>
    );
  }

  return (
    <Tab.Pane.Pane>
      <GroupSidebarTags
        tags={tags}
        onSave={updateTags} />
    </Tab.Pane.Pane>
  );
}

const Tags = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 5,
});